var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDollarIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "83E97D49-DBD7-481B-8351-1D1D5EE6348C") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TurnItBlue---Milestone-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "13.0_My-Library_03",
    transform: "translate(-866.000000, -612.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-20-Copy-8",
    transform: "translate(840.000000, 519.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(20.000000, 82.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3-Copy-4",
    transform: "translate(0.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "02.Icons-/-Basic-/-Solid-/-Rank",
    transform: "translate(6.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9569608,13.2313002 C14.9666176,11.896368 14.4469118,10.8406169 13.4102941,10.0950558 C12.6096569,9.52101508 11.6380392,9.22157617 10.6982843,8.93383409 C8.74063725,8.33122323 8.1727451,8.01381599 8.1727451,7.0632368 C8.1727451,6.0043997 9.52794118,5.62766214 10.6880882,5.62766214 C11.5329902,5.62766214 12.505049,5.8943997 13.1087255,6.28970287 L14.3055392,4.40765762 C13.5165686,3.88831825 12.4367647,3.53407843 11.3704902,3.42412821 L11.3704902,1.66666667 L9.1627451,1.66666667 L9.1627451,3.54736802 C7.2002451,3.98572549 5.96397059,5.28810558 5.96397059,7.0632368 C5.96397059,8.3064359 6.4727451,9.29235445 7.47328431,9.98774359 C8.23426471,10.5186305 9.16235294,10.8036848 10.0588725,11.0796802 C11.9790686,11.6690015 12.7588235,12.0281192 12.749951,13.2174133 L12.749902,13.2261735 C12.749902,14.2243861 11.4471078,14.5792232 10.3309804,14.5792232 C9.27666667,14.5792232 8.13014706,14.1100558 7.4802451,13.4124766 L5.87637255,14.9529246 C6.69941176,15.8368069 7.89519608,16.4617164 9.16269608,16.7066531 L9.16269608,18.5402187 L11.3704902,18.5402187 L11.3704902,16.7461237 C13.5512255,16.4291644 14.9548039,15.0960739 14.9569608,13.2313002 Z",
    id: "Path",
    fill: "currentColor"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarIcon);
export default __webpack_public_path__ + "static/media/DollarIcon.20c5aec468c40184a69bdaa7f81c7504.svg";
export { ForwardRef as ReactComponent };